let cache = {};
let maxSize = 3;

const defaultNamespace = '__default';

const normalizeNamespace = (namespace) => namespace || defaultNamespace;

const isWithinTTL = (cacheItem) => !cacheItem.ttl || (Date.now() - cacheItem.timestamp) / 1000 <= cacheItem.ttl;

const initNamespace = (namespace) => {
    cache[namespace] = [];
};

const hasNamespace = (namespace) => !!cache[namespace];

const removeOutdated = (namespace) => {
    if (cache[namespace]) {
        cache[namespace] = cache[namespace].filter(isWithinTTL);
    }
};

const getCached = (key, namespace) => {
    const normalizedNamespace = normalizeNamespace(namespace);
    removeOutdated(normalizedNamespace);
    if (hasNamespace(normalizedNamespace)) {
        const item = cache[normalizedNamespace].find((entry) => entry.key === key);
        if (item !== undefined) {
            return item.value;
        }
    }
};

const hasKey = (key, namespace) => {
    const normalizedNamespace = normalizeNamespace(namespace);
    removeOutdated(normalizedNamespace);
    return hasNamespace(normalizedNamespace) && cache[normalizedNamespace].find((item) => item.key === key) !== undefined;
};

/**
 * Stores a value inside the memory cache
 *
 * @param key
 * @param value
 * @param namespace [optional]
 * @param ttl [optional] Time to live in seconds
 */
const store = (key, value, namespace, ttl) => {
    const normalizedNamespace = normalizeNamespace(namespace);
    if (hasKey(key, normalizedNamespace)) {
        cache[normalizedNamespace] = cache[normalizedNamespace].map((item) => (item.key === key ? {...item, value: value} : item));
    } else {
        if (!hasNamespace(normalizedNamespace)) {
            initNamespace(normalizedNamespace);
        }

        cache[normalizedNamespace].unshift({
            key: key,
            value: value,
            ttl: ttl,
            timestamp: new Date().getTime()
        });

        while (cache[normalizedNamespace].length > maxSize) {
            cache[normalizedNamespace].pop();
        }
    }
};

const reset = () => {
    cache = {};
};

export {hasKey, getCached, store, reset};
